import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { US_STATES } from "@/constants/general";
import { forwardRef } from "react";

export const StateSelect = forwardRef(
  ({ value, onChange, placeholder, className, ...props }, ref) => {
    return (
      <Select onValueChange={onChange} defaultValue={value} {...props}>
        <SelectTrigger className={className}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent className="max-h-[300px]">
          {US_STATES.map((state) => (
            <SelectItem key={state.abbreviation} value={state.abbreviation}>
              {state.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }
);
